export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'comprasUpload',
      displayName: 'menu.comprasUpload',
      meta: {
        icon: 'upload_file',
      },
    },
    {
      name: 'comprasProcesadas',
      displayName: 'menu.comprasProcesadas',
      meta: {
        icon: 'add_shopping_cart',
      },
    },
    {
      name: 'comprasSriIngreso',
      displayName: 'menu.comprasSriIngreso',
      meta: {
        icon: 'add_shopping_cart',
      },
    },
    {
      name: 'comprasSriList',
      displayName: 'menu.comprasSriList',
      meta: {
        icon: 'add_shopping_cart',
      },
    },
  ] as INavigationRoute[],
}
